import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=473cac44&"
import script from "./UserCreate.vue?vue&type=script&lang=ts&"
export * from "./UserCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports